const c = ({
  permission: s,
  component: t,
  role: i
}) => i.permissions.some(
  (e) => e.name === s && e.component === t
), d = ({
  roles: s,
  permissionNames: t,
  component: i,
  scopeId: e
}) => s == null ? void 0 : s.some(
  (n) => {
    var a;
    return (a = n == null ? void 0 : n.scopes) == null ? void 0 : a.some(
      (m) => m.object_id === e && t.every(
        (v) => c({ role: n, permission: v, component: i })
      )
    );
  }
), U = ({
  scopeId: s,
  permissionNames: t,
  roles: i,
  component: e
}) => s ? d({
  roles: i,
  permissionNames: t,
  component: e,
  scopeId: s
}) : t.every(
  (n) => i.some((a) => c({ role: a, permission: n, component: e }))
);
export {
  U as validateUserHasRbacPermissions
};
//# sourceMappingURL=validateUserHasRbacPermissions.js.map
